import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDoubleRight, faAngleDoubleLeft, faAngleRight, faAngleLeft, faCheckCircle, faChevronDown, faChevronUp, faExclamationCircle, faExclamationTriangle, faStepForward, faStepBackward, faUserCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import 'react-placeholder/lib/reactPlaceholder.css';
library.add(faAngleDoubleRight, faAngleDoubleLeft, faAngleRight, faAngleLeft, faCheckCircle, faChevronDown, faChevronUp, faExclamationCircle, faExclamationTriangle, faStepForward, faStepBackward, faUserCircle, faSpinner);
export { default as Breadcrumbs } from './Breadcrumbs';
export { default as SortableTable } from './SortableTable';
export { Row, Col, Card } from './Layout';
export { default as Loader } from './Loader';
export { Toast, success, error, warning } from './Toast';
export { default as ScrollToTop } from './ScrollToTop';
export { default as Header } from './Header';
export { default as Pagination } from './Pagination';
export { default as Sidebar } from './Sidebar';
export { default as Button } from './Button';
export { default as Chip } from './Chip';
export { default as ImgWithPlaceholder } from './ImgWithPlaceholder';
export { default as FullScreenModal } from './FullScreenModal';
export { default as UserInfo } from './UserInfo';